import React, { memo } from 'react';
import SectionHeader from 'features/invest/components/SectionHeader';
import GroupTransaction from './GroupTransaction';
const GroupTransactionRow = ({ item, usersByIds, handleTransactionPress, }) => {
    if ('sectionTitle' in item) {
        return <SectionHeader title={item.sectionTitle}/>;
    }
    return (<GroupTransaction withWrapper transaction={item} key={String(item.id)} usersByIds={usersByIds} onPress={handleTransactionPress}/>);
};
export default memo(GroupTransactionRow);
